package pl.michal_cyran.brand_hub.subpages.tutoring.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaStar
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.ColorPalettes
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseIn
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.components.widgets.MarkedText
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun TestimonialCard(
    text: String,
    author: String,
    description: String,
    modifier: Modifier = Modifier,
    index: Int = 0,
) {
    val cm = ColorMode.current.toSitePalette()

    VisibilityAware { isVisible ->
        Box(
            modifier = CardStyle.toModifier()
                .backgroundColor(cm.cardBg)
                .then(modifier)
                .opacity(if (isVisible) 1 else 0)
                .transform {
                    translateY(if (isVisible) 0.px else 30.px)
                    scale(if (isVisible) 1.0 else 0.92)
                }
                .transition(
                    Transition.of("opacity", 0.5.s, EaseOut, (index * 150).ms),
                    Transition.of("transform", 0.5.s, EaseOut, (index * 150).ms)
                )
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxSize()
            ) {
                Row(
                    horizontalArrangement = Arrangement.spacedBy(5.px),
                    modifier = Modifier.padding(bottom = 8.px)
                ) {
                    repeat(5) { starIndex ->
                        FaStar(
                            style = IconStyle.FILLED,
                            modifier = Modifier
                                .color(Colors.Cyan)
                                .opacity(if (isVisible) 1 else 0)
                                .transform { scale(if (isVisible) 1.0 else 0.3) }
                                .transition(
                                    Transition.of(
                                        "opacity", 0.3.s, EaseOut,
                                        (index * 150 + 300 + starIndex * 80).ms
                                    ),
                                    Transition.of(
                                        "transform", 0.3.s, EaseIn,
                                        (index * 150 + 300 + starIndex * 80).ms
                                    )
                                )
                        )
                    }
                }

                P(
                    attrs = Modifier.weight(1).toAttrs()
                ) {
                    Text(text)
                }

                Span {
                    MarkedText(author)
                    Text(description)
                }
            }
        }
    }
}